import { render } from "./VInputMask.vue?vue&type=template&id=4da032cf&ts=true"
import script from "./VInputMask.vue?vue&type=script&lang=ts"
export * from "./VInputMask.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__